import 'babel-polyfill'
import 'intl'
import React from 'react'
import { render as reactDOMRender } from 'react-dom'
import { browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import configureStore from './store/configureStore'
import './utils/polyfill'
import Root from './containers/Root'

// Internationalization
import { IntlProvider, addLocaleData } from 'react-intl'
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'

// Our translated strings
import enLocaleData from '../build/locales/en.json'
import esLocaleData from '../build/locales/es.json'

addLocaleData([...en, ...es])

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const language =
  (navigator.languages && navigator.languages[0]) ||
  navigator.language ||
  navigator.userLanguage

// Split locales with a region code
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0]

// Try full locale, try locale without region code, fallback to 'en'
const messages =
  languageWithoutRegionCode === 'en' || language === 'en'
    ? enLocaleData
    : esLocaleData

const store = configureStore()
const history = syncHistoryWithStore(browserHistory, store)
const MOUNT_NODE = document.getElementById('root')

let render = () => {
  reactDOMRender(
    <IntlProvider locale={navigator.language} messages={messages}>
      <Root store={store} history={history} />
    </IntlProvider>,
    MOUNT_NODE
  )
}

// Development Tools
// ------------------------------------
if (__DEV__) {
  // why-did-you-update perf monitoring
  // let createClass = React.createClass
  // Object.defineProperty(React, 'createClass', {
  //   set: (nextCreateClass) => {
  //     createClass = nextCreateClass
  //   }
  // })
  // console.log('wrapping with whyDidYouUpdate')
  // const { whyDidYouUpdate } = require('why-did-you-update')
  // whyDidYouUpdate(React, { exclude: /^Connect/ })

  if (module.hot) {
    const renderApp = render
    const renderError = error => {
      const RedBox = require('redbox-react').default

      reactDOMRender(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        console.error(e)
        renderError(e)
      }
    }

    // Setup hot module replacement
    if (module.hot) {
      module.hot.accept()
    }
  }
}

// Let's Go!
// ------------------------------------
if (!process.env.NODE_ENV !== 'test') render()



// WEBPACK FOOTER //
// ./src/index.js